<template>
    <div class="search-box">
        <div  class="home-search" :class="{'home-search1':($store.state.home.scrollState>0 || $store.state.home.navIndex===2)}" >
            <input 
            placeholder="請輸入關鍵字搜索課程"
            ref="search"
            v-model="search"
            type="text" 
            @keyup='searchDown'
            @focus="searchState=true"
            @blur="inputBlur"
            >
            <button class="el-icon-search p-pointer" @click="searchData"></button>
        </div>
        <transition>
            <ul v-show="(searchlists.length>0 && searchState)">
                <template v-for="(item,index) in searchlists" >
                    <li class="p-pointer" :style="{background: keyupIndex === index ? 'rgba(0, 0, 0, .1)' : ''}" :key="item.id" @click="goPage(item)">
                        <div v-html="showDate(item.name)"></div>
                    </li>
                </template>
            </ul>
        </transition>
    </div>
</template>
<script>
export default {
    data(){
        return {
            focus:false,
            search:'',
            searchState:true,
            keyupIndex: '',
        }
    },
    props:{
        searchlists:{
            type: [Array],
            default: function () {
                return [];
            }
        }
    },
    computed:{
        
    },
    watch:{
        search(v){
            const value = v.replace(/(^\s*)|(\s*$)/g, "") // 去除首尾空格
            if(value === ''){
                this.searchState=false;
            } else {
                this.searchState=true;
                this.$emit('searchChange', value);
            }
            this.keyupIndex = ''
        },
        $route(to,from){        //页面改变清空搜索
            if(to.name!='searchList'){
                this.search='';
            }
        }
    },
    methods:{
        searchData(){
            this.$store.commit('setBreadcrumb','')
            this.$refs.search.blur()
            this.$router.push({path:'/search/list',query:{val:this.search,title:'搜索結果'}})
        },
        goPage(item){
            this.$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})
            this.searchState=false
        },
        inputBlur(){
            this.keyupIndex = ''
            setTimeout(()=>{this.searchState=false},300)
        },
        //高亮关键字
        showDate (val) {
            if (val.indexOf(this.search) !== -1 && this.search !== '') {
                return val.replace(this.search, '<font color="#409EFF">' + this.search + '</font>')
            } else {
                return val
            }
        },
        searchDown({keyCode}){
            const searchlistsLength = this.searchlists.length-1;
            if (keyCode === 13) {
                if (this.keyupIndex !== '') {
                    const { id, name } = this.searchlists[this.keyupIndex]
                    this.$router.push({path:'/home/lessons/study',query:{id,title:name}})
                } else {
                    this.searchData()
                }
                this.searchState = false
            } else if (keyCode === 38) {
                if (this.keyupIndex === '' || this.keyupIndex <= 0) {
                    this.keyupIndex = searchlistsLength
                } else {
                    this.keyupIndex-=1
                }
            } else if (keyCode === 40) {
                if (this.keyupIndex === '' || this.keyupIndex >= searchlistsLength) {
                    this.keyupIndex = 0
                } else {
                    this.keyupIndex+=1
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.v-enter,.v-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
.v-enter-active,
.v-leave-active{
    transition: all 0.2s ease;
}
.search-box{
    position: relative;
    >ul{
        color: #333333;
        position: absolute;
        top: 44px;
        width:750px;
        // padding: 0 30px        box-sizing: border-box;
        background:rgba(255,255,255,1);
        box-shadow:0px 3px 10px rgba(51,51,51,0.3);
        li{
            padding: 0 30px;
            
            >div{
                padding: 10px 0;
                border-bottom: 1px solid #EEEEEE;
            }
            &:hover{
                background: rgba(0, 0, 0, .1)
            }
        }
    }
}
.home-search{
    width: 417px;
    height: 37px;
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    input{
        height: 100%;
        border: 0;
        width: 360px;
        font-size:12px;
        padding-left: 15px;
        box-sizing: border-box;
        float: left;
        background:rgba(255,255,255,.2);
        outline:none;
    }
    button{
        float: left;
        border: 0;
        height: 100%;
        width: 57px;
        color: #4D8EF6;
        background:rgba(255,255,255,0.8);
        outline:none;
    }
    input::-webkit-input-placeholder{
        color:#ffffff;
        opacity:.5;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#ffffff;
        opacity:.5;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#ffffff;
        opacity:.5;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:#ffffff;
        opacity:.5;
    }
}
.home-search1{
    input{
        background:rgba(206,206,217,.3);
    }
    button{
        // background: #4D8EF6;
        color: #4D8EF6;
        background:rgba(244,244,249,0.8);
    }
    input::-webkit-input-placeholder{
        color:#ffffff;
        opacity:.5;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#ffffff;
        opacity:.5;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#ffffff;
        opacity:.5;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:#ffffff;
        opacity:.5;
    }
}
</style>
